export default __webpack_public_path__ + "static/media/okechukwu.e5d18f31.png";